(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/engine/assets/javascripts/utils/helpers.js') >= 0) return;  svs.modules.push('/components/tipsen/engine/assets/javascripts/utils/helpers.js'); "use strict";

const {
  useMemo
} = React;
const {
  useSelector
} = ReactRedux;
const {
  selectPixSystem
} = svs.components.tipsen.engine.selectors.engineSelectors;
const {
  generateXpertCoupon,
  generateXpertCouponBoard,
  generateSportPixCoupon,
  generateSportPixCouponBoard
} = svs.components.tipsen.engine.actions;
const PixSystem = svs.components.tipsen.engine.constants.PixSystem;
const useGenerateXpertCouponAction = () => {
  const pixSystem = useSelector(selectPixSystem);
  return useMemo(() => {
    const actionFn = pixSystem === PixSystem.Xperten ? generateXpertCoupon : generateSportPixCoupon;
    return actionFn;
  }, [pixSystem]);
};
const useGenerateXpertCouponBoardAction = () => {
  const pixSystem = useSelector(selectPixSystem);
  return useMemo(() => {
    const actionFn = pixSystem === PixSystem.Xperten ? generateXpertCouponBoard : generateSportPixCouponBoard;
    return actionFn;
  }, [pixSystem]);
};
setGlobal('svs.components.tipsen.engine.utils.helpers', {
  useGenerateXpertCouponAction,
  useGenerateXpertCouponBoardAction
});
 })(window);